import { ApiError, api } from '../api/client';
import { renderWordmark } from './logo';
export function renderLogin(root, onAuthed, goToForgot) {
    root.innerHTML = `
    <div class="auth-screen">
      ${renderWordmark()}
      <p class="brand-sub">Pirate roguelite. Cards, coins, mutiny.</p>
      <div class="auth-card">
        <div class="auth-tabs">
          <button id="tab-login" class="tab-btn tab-btn--active">Sign in</button>
          <button id="tab-signup" class="tab-btn">New captain</button>
        </div>
        <form id="auth-form" class="auth-form">
          <label>Email <input name="email" type="email" required autocomplete="email" /></label>
          <label class="signup-only" style="display:none">Captain name <input name="display_name" maxlength="32" autocomplete="username" /></label>
          <label>Password <input name="password" type="password" minlength="6" required autocomplete="current-password" /></label>
          <div class="auth-error" id="auth-error"></div>
          <button type="submit" class="btn btn--primary auth-submit">Sign in</button>
          <div class="auth-links login-only">
            <a href="#/forgot-password" id="forgot-link">Forgot your password?</a>
          </div>
        </form>
        <div class="auth-divider"><span>or</span></div>
        <button type="button" class="btn btn--ghost auth-guest-btn" id="guest-btn">
          ⚓ Play as Guest
        </button>
        <p class="auth-guest-blurb">No email needed — try Solo Runs right away. You can save your progress to a real account anytime from the lobby.</p>
      </div>
    </div>
  `;
    let mode = 'login';
    const tabLogin = root.querySelector('#tab-login');
    const tabSignup = root.querySelector('#tab-signup');
    const form = root.querySelector('#auth-form');
    const submit = form.querySelector('.auth-submit');
    const signupOnly = form.querySelector('.signup-only');
    const loginOnly = form.querySelector('.login-only');
    const errEl = root.querySelector('#auth-error');
    function setMode(m) {
        mode = m;
        tabLogin.classList.toggle('tab-btn--active', m === 'login');
        tabSignup.classList.toggle('tab-btn--active', m === 'signup');
        signupOnly.style.display = m === 'signup' ? '' : 'none';
        loginOnly.style.display = m === 'login' ? '' : 'none';
        submit.textContent = m === 'login' ? 'Sign in' : 'Create captain';
        errEl.textContent = '';
    }
    tabLogin.addEventListener('click', () => setMode('login'));
    tabSignup.addEventListener('click', () => setMode('signup'));
    root.querySelector('#forgot-link')?.addEventListener('click', (e) => {
        if (goToForgot) {
            e.preventDefault();
            goToForgot();
        }
    });
    const guestBtn = root.querySelector('#guest-btn');
    guestBtn?.addEventListener('click', async () => {
        guestBtn.disabled = true;
        const original = guestBtn.textContent;
        guestBtn.textContent = 'Setting sail…';
        errEl.textContent = '';
        try {
            await api.anonymousSignup();
            onAuthed();
        }
        catch (err) {
            errEl.textContent = err instanceof ApiError ? err.message : err.message;
            guestBtn.disabled = false;
            guestBtn.textContent = original;
        }
    });
    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        errEl.textContent = '';
        const data = new FormData(form);
        const email = String(data.get('email') ?? '');
        const password = String(data.get('password') ?? '');
        const displayName = String(data.get('display_name') ?? '').trim();
        submit.disabled = true;
        try {
            if (mode === 'signup') {
                if (!displayName)
                    throw new Error('Pick a captain name.');
                await api.signup(email, password, displayName);
            }
            else {
                const res = await api.login(email, password);
                if ('requires_2fa' in res && res.requires_2fa) {
                    renderTwoFactorStep(root, res.challenge_token, onAuthed);
                    return;
                }
            }
            onAuthed();
        }
        catch (err) {
            errEl.textContent = err instanceof ApiError ? err.message : err.message;
        }
        finally {
            submit.disabled = false;
        }
    });
}
function renderTwoFactorStep(root, challenge, onAuthed) {
    root.innerHTML = `
    <div class="auth-screen">
      ${renderWordmark()}
      <p class="brand-sub">Two-factor sign-in</p>
      <div class="auth-card">
        <h2 class="auth-title">Enter your code</h2>
        <p class="auth-blurb">Open your authenticator app and enter the 6-digit code. You can also use a recovery code (xxxx-xxxx) if you've lost your device.</p>
        <form id="twofa-form" class="auth-form">
          <label>Code
            <input id="twofa-code" type="text" inputmode="text" autocomplete="one-time-code"
                   maxlength="11" required autofocus />
          </label>
          <div class="auth-error" id="twofa-error"></div>
          <button type="submit" class="btn btn--primary auth-submit">Verify</button>
        </form>
      </div>
    </div>
  `;
    const form = root.querySelector('#twofa-form');
    const input = root.querySelector('#twofa-code');
    const errEl = root.querySelector('#twofa-error');
    const submit = form.querySelector('.auth-submit');
    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        errEl.textContent = '';
        const code = input.value.trim();
        if (!code)
            return;
        submit.disabled = true;
        submit.textContent = 'Verifying…';
        try {
            await api.twoFactorVerify(challenge, code);
            onAuthed();
        }
        catch (err) {
            errEl.textContent = err instanceof ApiError ? err.message : err.message;
            submit.disabled = false;
            submit.textContent = 'Verify';
        }
    });
}
